import { createSelector } from '@ngrx/store';

import { Content } from '@mobi/oiv-viewer-utils-ng-jslib';
import { OIV_TYPE } from '@mobi/oiv-viewer-xml-parser-ng-jslib';

import { oivViewerFeature } from './oiv-viewer.reducer';

const selectChapters = oivViewerFeature.selectAvbChapters;
const selectAvbMetaData = oivViewerFeature.selectAvbMetadata;
const selectAvbCoverSheet = oivViewerFeature.selectAvbCoverSheet;
const selectLoadingError = oivViewerFeature.selectLoadingError;
const selectIndex = oivViewerFeature.selectIndex;
const selectLoadingIndex = oivViewerFeature.selectLoadingIndex;
const selectFeatures = oivViewerFeature.selectFeatures;

const selectChapterById = (eId: string) =>
    createSelector(selectChapters, (state: Content[]) =>
        state.find(chapter => chapter.type === OIV_TYPE.CHAPTER && chapter.eId === eId),
    );

const isErrorCall = createSelector(selectLoadingError, (state: boolean) => state);

const selectUrlName = createSelector(selectAvbMetaData, state => state.urlName);

export const fromOivViewer = {
    selectChapters,
    selectUrlName,
    selectAvbMetaData,
    selectAvbCoverSheet,
    selectIndex,
    selectLoadingIndex,
    isErrorCall,
    selectChapterById,
    selectFeatures,
};
